import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitialState {
  refetch: boolean;
}

const initialState: InitialState = {
  refetch: false,
};

export const slice = createSlice({
  name: 'codeGeneratorSlice',
  initialState: {
    ...initialState,
  },
  reducers: {
    setRefetch(state, action: PayloadAction<boolean>) {
      state.refetch = action.payload;
    },
  },
});

export const { setRefetch } = slice.actions;
export default slice.reducer;
